import { CopyError } from '../copy/text.js';
import { viewerStrings } from '../copy/strings.js';
import { getTheme } from './catalog.js';

export interface AppearancePreference {
  version: 1;
  theme: number;
}
export const appearanceKey = 'cdr-clarity:appearance:v1';

export function readAppearance(storage: Pick<Storage, 'getItem'>): AppearancePreference {
  const saved = storage.getItem(appearanceKey);
  if (!saved) return { version: 1, theme: 4 };
  const value: unknown = JSON.parse(saved);
  if (
    !value ||
    typeof value !== 'object' ||
    !('version' in value) ||
    value.version !== 1 ||
    !('theme' in value) ||
    typeof value.theme !== 'number'
  )
    throw new CopyError(viewerStrings.themesPreferences.savedAppearanceIsInvalidChooseATheme);
  getTheme(value.theme);
  return { version: 1, theme: value.theme };
}

export function saveAppearance(
  storage: Pick<Storage, 'setItem'>,
  value: AppearancePreference,
): void {
  storage.setItem(appearanceKey, JSON.stringify(value));
}
